import { useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { CheckCircle2, ShieldCheck, BarChart3, Zap, Users, ArrowRight, Sparkles, Lock, CloudUpload, Server, Star, GitCompare, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function Index() {
  const [npis, setNpis] = useState(5);
  const [mx, setMx] = useState({ x: 50, y: 50 });
  const total = useMemo(() => calcPrice(npis), [npis]);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>MIPS QCDR — Modern MIPS Reporting SaaS</title>
        <meta
          name="description"
          content="CMS‑approved QCDR for MIPS: real‑time analytics, gap closure, bulk updates, CMS submission—and tiered plans for any size practice."
        />
        <link rel="canonical" href="/" />
        <meta property="og:title" content="MIPS QCDR — Modern MIPS Reporting" />
        <meta
          property="og:description"
          content="Streamline MIPS with our CMS‑approved QCDR: analytics, gap closure, bulk updates, submission, and tiered plans."
        />
      </Helmet>
      {/* Placeholder simplified content to keep page functional; full marketing content remains in original file */}
      <main className="container mx-auto max-w-3xl px-4 py-12">
        <h1 className="text-2xl font-semibold tracking-tight">Registration</h1>
        <p className="mt-2 text-muted-foreground">Start your onboarding workflow.</p>
        <div className="mt-6">
          <Button asChild>
            <Link to="/onboarding">Begin</Link>
          </Button>
        </div>
      </main>
    </div>
  );
}

const TIERS = [
  { upTo: 5, price: 199 },
  { upTo: 20, price: 179 },
  { upTo: Infinity, price: 159 },
];

function calcPrice(npis: number) {
  const tier = TIERS.find((t) => npis <= t.upTo)!;
  return npis * tier.price;
}



